export const ROUTES = {
  WELCOME: '/',
  SIGNUP: '/signup',
  SIGNIN: '/signin',
  VERIFY: '/verify',
  VERIFIED: '/verified',
  PROFILE: '/profile',
  CONNECT: '/connect',
  HOME: '/home',
  CREATE: {
    PICK: '/create/pick',
    PROMPTS: '/create/prompts',
    BUILD: '/create/story',
    ORGANIZE: '/create/organize',
    PREVIEW: '/create/preview',
    SHARE: '/create/share',
    DONE: '/create/done',
    BOOK: '/create/book',
  },
  NETWORK: '/network',
  EDIT: {
    VIDEO: '/edit/video',
    STORY: '/edit/story',
    SUCCESS: '/edit/success',
  },
  SUBSCRIBE: '/subscribe',
  DESIGN: '/design',
  SETTINGS: '/settings',
  SHOP: '/shop',
  MERCHANDISE_SUCCESS: '/merchandise/success',
} as const;

// Pre-authentication screens. An already-signed-in user landing on one of these is
// redirected to /home. Onboarding screens (PROFILE, CONNECT) and verification (VERIFY, VERIFIED)
// are deliberately NOT here: they run during/after authentication, so the auth listener must not
// prematurely force-navigate to /home while VerifyScreen coordinates the onboarding routing.
export const AUTH_ROUTES = [
  ROUTES.WELCOME,
  ROUTES.SIGNUP,
  ROUTES.SIGNIN,
] as const;

export const FULL_SCREEN_ROUTES = [ROUTES.EDIT.VIDEO] as const;
